import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CardApiService} from '@modules/equipment-card/services/card.api.service';
import {TechnicalDeviceTechnicalCardApiService} from '@api/technical-device-technical-card.api.service';
import {ConclusionFormDataService} from '../../services/conclusion-form-data.service';
import {RoutesStorage} from '@helpers/routes.helper';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';

@Component({
    selector: 'app-conclusion-equipment-list',
    templateUrl: './conclusion-equipment-list.component.html',
    styleUrls: ['./conclusion-equipment-list.component.scss'],
    providers: [
        {provide: 'EquipmentCardSelectApiService', useClass: TechnicalDeviceTechnicalCardApiService},
    ]
})
export class ConclusionEquipmentListComponent implements OnInit, OnDestroy {
    public selectedIds: number[] = [];

    public cardList: EquipmentCardInterfaces.Card.ItemView[] = [];

    public objectEquipmentViewList: string;

    public equipmentModalTitle: string;

    public isFetching$ = new BehaviorSubject<boolean>(false);

    constructor(
        private route: ActivatedRoute,
        private equipmentApi: CardApiService,
        public formService: ConclusionFormDataService,
        @Inject('EquipmentCardSelectApiService') private techcardEquipmentApi,
    ) {
    }

    ngOnInit() {
        this.cardList = this.route.snapshot.data.equipment || [];

        this.techcardEquipmentApi.technicalCardId = this.formService.technicalCardId;

        this.setEquipmentValue();

        this.objectEquipmentViewList = RoutesStorage.WorkingObject.viewEquipment(this.formService.objectId);

        this.equipmentModalTitle = `Оборудования на объекте по методу ${this.formService.technicalCard.method.short_title}`;
    }

    setEquipmentValue() {
        const ids = this.cardList.map(item => +item.id);
        this.selectedIds = ids;
        this.formService.updateEquipment(ids);
    }

    onEquipmentSelect(ids: number[]) {
        this.isFetching$.next(true);
        this.equipmentApi.get({
            queryParams: {
                id: ids,
            }
        }).subscribe((items) => {
            this.cardList = items || [];
            this.setEquipmentValue();
            this.isFetching$.next(false);
        }, () => {
            this.isFetching$.next(false);
        });
    }

    removeItem(card: EquipmentCardInterfaces.Card.ItemView) {
        this.cardList = this.cardList.filter(item => item.id !== card.id);
        this.setEquipmentValue();
    }

    ngOnDestroy() {

    }
}
